import React from 'react'

function ZoomInIcon() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#fff"
      d="M11 6.5a1 1 0 1 0-2 0V9H6.5a1 1 0 1 0 0 2H9v2.5a1 1 0 1 0 2 0V11h2.5a1 1 0 1 0 0-2H11V6.5Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M10 1a9 9 0 1 0 5.618 16.032l4.675 4.675a1 1 0 0 0 1.414-1.414l-4.675-4.675A9 9 0 0 0 10 1Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
      clipRule="evenodd"
    />
  </svg>
  )
}

export default ZoomInIcon
